import { userApi, sellerApi, riderApi, adminApi } from "./api";

const getApi = (role) => {
  if (role === "seller") return sellerApi;
  if (role === "rider") return riderApi;
  if (role === "admin") return adminApi;
  return userApi;
};

export const createConversationApi = async (role, payload) => {
  const { data } = await getApi(role).post("/api/v1/chat/conversation", payload);
  return data;
};

export const getConversationsApi = async (role) => {
  const { data } = await getApi(role).get("/api/v1/chat/conversations");
  return data;
};

export const getMessagesApi = async (role, conversationId, params) => {
  const { data } = await getApi(role).get(`/api/v1/chat/conversations/${conversationId}/messages`, { params });
  return data;
};

export const sendMessageApi = async (role, conversationId, payload) => {
  const { data } = await getApi(role).post(`/api/v1/chat/conversations/${conversationId}/messages`, payload);
  return data;
};

export const markAsReadApi = async (role, conversationId) => {
  const { data } = await getApi(role).patch(`/api/v1/chat/conversations/${conversationId}/read`);
  return data;
};

export const getUnreadCountApi = async (role) => {
  const { data } = await getApi(role).get("/api/v1/chat/unread-count");
  return data;
};
